import './bootstrap';
import store from './store';
import Navigation from './custom/Navigation';
import Vue from 'vue';

document.addEventListener('DOMContentLoaded', () => {
    const navIcon = document.getElementById('nav-icon');
    const navbarNav = document.getElementById('navbarNav');
    const mainMenu = document.querySelectorAll('.main-menu');
    const subMenues = document.querySelectorAll('.sub-menu');
    const navigation = new Navigation();

    navIcon.addEventListener('click', () => {
        navigation.toggleMobileNavigation(navIcon, navbarNav, subMenues);
    });

    if (mainMenu && subMenues) {
        mainMenu.forEach(el => el.addEventListener('touchstart', event => {
            navigation.showTouchNavigation(el, event, mainMenu, subMenues);
        }));
    }

    window.addEventListener('resize', () => {
        navigation.hideCanvasNavigation(navIcon, navbarNav, subMenues);
    });

    const app = new Vue({
        el: '#app',
        store,
    });
});
